import { Item } from '@radix-ui/react-toggle-group';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './toggle-group.scss';

type Props = ComponentPropsWithoutRef<typeof Item>;
export const ToggleGroupItem = ({ className, children, ...props }: Props) => {
    return (
        <Item className={cn('toggle-group__item', className)} {...props}>
            {children}
        </Item>
    );
};
